<template>
  Pages
</template>

<script>
export default {};
</script>

<style></style>
